import { useScrollParent } from '@/hooks/useScrollParent'
import { isMobile } from '@/utils/constants'
import { useEventListener } from '@vueuse/core'

export const useContactUs = (el) => {
  const show = ref(false)

  const scroller = useScrollParent(el)

  let lastActiveScrollTop = window.innerHeight * 2
  let longestScrollTop = 0

  const cleanup = useEventListener(scroller, 'scroll', (el) => {
    const element = el.target.scrollingElement ?? el.target

    const scrollTop = element.scrollTop
    if (scrollTop > (lastActiveScrollTop + window.innerHeight * 2)) {
      // 移动端只出现一次，PC端可重复出现
      if (isMobile) cleanup()
      show.value = true
    }
    longestScrollTop = Math.max(scrollTop, longestScrollTop)
  }, {
    passive: true
  })

  watch(show, (val) => {
    if (!val) lastActiveScrollTop = longestScrollTop
  })

  return { show }
}
